const catalogData = {
    newArrivals: [
      {
        title: 'Aurora',
        folder: 'Aurora2',
        images: [
          'Technozappy Studio 34.jpg',
          'Technozappy Studio 34a.jpg',
          'Technozappy Studio 39.jpg',
        ],
      },
      {
        title: 'Elite PlexiGlass',
        folder: 'Elite PlexiGlass PhotoBook',
        images: [
          'Technozappy Studio24109.jpg',
          'Technozappy Studio24110.jpg',
          'Technozappy Studio24113.jpg',
          'Technozappy Studio24142.jpg',
          'Technozappy Studio26952.jpg',
        ],
      },
      {
        title: 'Fleecy Glam',
        folder: 'Fleecy Glam PhotoBook',
        images: [
          'Technozappy Studio24093.jpg',
          'Technozappy Studio24096.jpg',
          'Technozappy Studio24097.jpg',
          'Technozappy Studio24128.jpg',
          'Technozappy Studio26953.jpg',
        ],
      },
      {
        title: 'Feather Luxe',
        folder: 'Feather Luxe PhotoBooks',
        images: [
          'Technozappy Studio24087.jpg',
          'Technozappy Studio24088.jpg',
          'Technozappy Studio24089.jpg',
          'Technozappy Studio24091.jpg',
          'Technozappy Studio24135.jpg',
        ],
      },
      {
        title: 'Mosaic',
        folder: 'Mosaic',
        images: [
          'Technozappy Studio 26.jpg',
          'Technozappy Studio 26a.jpg',
          'Technozappy Studio 37.jpg',
        ],
      },
      {
        title: 'Fleecy Glam',
        folder: 'Fleecy Glam',
        images: [
          'Technozappy Studio24106.jpg',
          'Technozappy Studio24107.jpg',
          'Technozappy Studio24108.jpg',
          'Technozappy Studio24138.jpg',
        ],
      },
      {
        title: 'Elite Radiance',
        folder: 'Elite Radiance',
        images: [
          'Technozappy Studio 14.jpg',
          'Technozappy Studio 15.jpg',
          'Technozappy Studio 16.jpg',
          'Technozappy Studio 17.jpg',
          'Technozappy Studio 18.jpg',
          'Technozappy Studio 19.jpg'
        ],
      },
    ],

    /****************************************************************************** */
    bestSellers: [
        {
          title: 'Acrylic Vista',
          folder: 'Acrylic Vista',
          images: [
            'Technozappy Studio 2.jpg',
            'Technozappy Studio 3.jpg',
            'Technozappy Studio 33.jpg',
            'Technozappy Studio 36.jpg',
            'Technozappy Studio 37.jpg',
            'Technozappy Studio 38.jpg',
            'Technozappy Studio 39.jpg',
          ],
        },
        {
            title: 'Aurora',
            folder: 'Aurora4',
            images: [
              'Technozappy Studio 29.jpg',
              'Technozappy Studio 41.jpg',
              'Technozappy Studio 41a.jpg',
            ],
          },
        {
          title: 'Elite PlexiGlass',
          folder: 'Elite PlexiGlass',
          images: [
            'Technozappy Studio29518.jpg',
            'Technozappy Studio29535.jpg',
            'Technozappy Studio29537.jpg',
            'Technozappy Studio29538.jpg',
            'Technozappy Studio29550.jpg',
          ],
        },
        {
            title: 'Fleecy Glam',
            folder: 'Fleecy Glam1',
            images: [
              'Technozappy Studio 5.jpg',
              'Technozappy Studio 5a.jpg',
              'Technozappy Studio 9.jpg',
            ],
          },
        {
            title: 'Feather Luxe',
            folder: 'Feather Luxe PhotoBook',
            images: [
              'Technozappy Studio 8.jpg',
              'Technozappy Studio 10.jpg',
              'Technozappy Studio 25.jpg',
              'Technozappy Studio 26.jpg',
              'Technozappy Studio 27.jpg',
              'Technozappy Studio 28.jpg',
            ],
          },
        {
            title: 'Elite Radiance',
            folder: 'Elite Radiance PhotoBooks',
            images: [
              'Technozappy Studio24114.jpg',
              'Technozappy Studio24115.jpg',
              'Technozappy Studio24117.jpg',
              'Technozappy Studio24118.jpg',
              'Technozappy Studio24146.jpg',
            ],
          },
      ],
  /****************************************************************************** */
    fullCollection: [
      {
        title: 'Aurora',
        folder: 'Aurora',
        images: [
          'Technozappy Studio 12.jpg',
          'Technozappy Studio 12a.jpg',
          'Technozappy Studio 47.jpg',
        ],
      },
      {
        title: 'Fleecy Glam',
        folder: 'Fleecy Glam4',
        images: [
          'Technozappy Studio 19.jpg',
          'Technozappy Studio 53.jpg',
          'Technozappy Studio 53a.jpg',
        ],
      },
      {
        title: 'The Arcane',
        folder: 'The Arcane PhotoBooks',
        images: [
          'Technozappy Studio24098.jpg',
          'Technozappy Studio24100.jpg',
          'Technozappy Studio24103.jpg',
          'Technozappy Studio24141.jpg',
          'Technozappy Studio26955.jpg',
        ],
      },
      {
        title: 'Elite PlexiGlass',
        folder: 'Elite PlexiGlass1',
        images: [
          'Technozappy Studio29491.jpg',
          'Technozappy Studio29493.jpg',
          'Technozappy Studio29566.jpg',
          'Technozappy Studio29567.jpg',
          'Technozappy Studio29568.jpg',
          'Technozappy Studio29569.jpg'
        ],
      },
      {
        title: 'Feather Luxe',
        folder: 'Feather Luxe',
        images: [
          'Technozappy Studio 47.jpg',
          'Technozappy Studio 47a.jpg',
          'Technozappy Studio.jpg',
        ],
      },
      {
        title: 'Elite Radiance',
        folder: 'Elite Radiance PhotoBook',
        images: [
          'Technozappy Studio29516.jpg',
          'Technozappy Studio29541.jpg',
          'Technozappy Studio29543.jpg',
          'Technozappy Studio29544.jpg',
          'Technozappy Studio29548.jpg',
        ],
      },
      {
        title: 'Fleecy Glam',
        folder: 'Fleecy Glam2',
        images: [
          'Technozappy Studio 14.jpg',
          'Technozappy Studio 19.jpg',
          'Technozappy Studio 19a.jpg',
        ],
      },
      {
        title: 'Mosaic',
        folder: 'Mosaic PhotoBook',
        images: [
          'Technozappy Studio29519.jpg',
          'Technozappy Studio29526.jpg',
          'Technozappy Studio29530.jpg',
          'Technozappy Studio29533.jpg',
          'Technozappy Studio29551.jpg',
        ],
      },
      {
        title: 'Mosaic',
        folder: 'Mosaic PhotoBooks',
        images: [
          'Technozappy Studio24080.jpg',
          'Technozappy Studio24084.jpg',
          'Technozappy Studio24085.jpg',
          'Technozappy Studio24086.jpg',
          'Technozappy Studio24124.jpg',
        ],
      },
      {
        title: 'Fleecy Glam',
        folder: 'Fleecy Glam3',
        images: [
          'Technozappy Studio 24.jpg',
          'Technozappy Studio 36.jpg',
          'Technozappy Studio 36s.jpg',
        ],
      },
      {
        title: 'Regalia',
        folder: 'Regalia',
        images: [
          'Technozappy Studio 16.jpg',
          'Technozappy Studio 52.jpg',
          'Technozappy Studio 52a.jpg',
        ],
      },
      {
        title: 'The Arcane',
        folder: 'The Arcane PhotoBook',
        images: [
          'Technozappy Studio29501.jpg',
          'Technozappy Studio29505.jpg',
          'Technozappy Studio29561.jpg',
          'Technozappy Studio29563.jpg',
          'Technozappy Studio29564.jpg',
          'Technozappy Studio29565.jpg',
        ],
      },
      // You can add remaining photo books here if they don’t fit into bestSellers or newArrivals
    ],
  
    comingSoon: [
      {
        title: 'Feather Luxe New Version',
        folder: 'Feather Luxe',
        images: [],
        comingSoon: true,
      },
      {
        title: 'Regalia New Version',
        folder: 'Regalia',
        images: [],
        comingSoon: true,
      },
    ],
  };
  
  export default catalogData;
  